import { render, staticRenderFns } from "./imagePage.vue?vue&type=template&id=35f0044c&scoped=true&"
import script from "./imagePage.vue?vue&type=script&lang=js&"
export * from "./imagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0044c",
  null
  
)

export default component.exports